import {
    orgActBookedOnDate,
    orgActBookingCount,
    orgActBookingList,
    orgActDashboardData,
    orgActdashFun,
    orgActSlotBookings
} from '../../../../api/orgActAPI';
import errorHandle from '../../../../utils/errorHandle';

export const fetchActDashboardBookingsData = async (
    setTableData,
    setTotalCount,
    setKpiData,
    setLoading,
    selected,
    bookingsOnly,
    limit,
    offset
) => {
    setLoading(true);
    try {
        const response = await orgActDashboardData(selected, bookingsOnly, offset, limit);
        setTableData(response.data.data);
        setTotalCount(response.data.totalCount);
        setKpiData(response.data.stats);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const fetchActDashboardKpiData = async (setTotalCount, setLoading) => {
    setLoading(true);
    try {
        const response = await orgActdashFun();
        setTotalCount(response.data);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const fetchActDashboardBookingsCount = async (setTotalCount, setLoading, selected) => {
    setLoading(true);
    try {
        const response = await orgActBookingCount(selected, '');
        setTotalCount(response.data.bookCount);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const fetchActBookedOnDate = async (actDateId, slotId, setActDateDetails, setSlotDetails, setLoading) => {
    setLoading(true);
    try {
        const response = await orgActSlotBookings(actDateId, slotId);
        setActDateDetails(response.data.data);
        setSlotDetails(response.data.slot);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
